import { useState, useEffect } from 'react';

/**
 * Detects if the user is viewing on a smartphone (not tablet/desktop).
 * Uses viewport width threshold of 640px - typical phone breakpoint.
 * Tablets in portrait are usually 768px+, so this targets phones specifically.
 * @returns {boolean} true when viewport width <= 640px
 */
export const useIsSmartphone = () => {
  const [isSmartphone, setIsSmartphone] = useState(false);

  useEffect(() => {
    const checkSmartphone = () => {
      setIsSmartphone(window.innerWidth <= 640);
    };

    // Initial check after mount (window not available during SSR)
    checkSmartphone();

    const mediaQuery = window.matchMedia('(max-width: 640px)');
    const handleChange = (e) => setIsSmartphone(e.matches);
    mediaQuery.addEventListener('change', handleChange);

    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return isSmartphone;
};
